import normalPatientApi from '@/core/services/api/patient'
import insurancePatientApi from '@/core/services/apiInsurance/patient'
import * as normalCitiesApi from '@/core/services/api/admin/cities'
import * as insuranceCitiesApi from '@/core/services/apiInsurance/admin/cities'
import normalFacilitiesApi from '@/core/services/api/admin/facilities'
import insuranceFacilitiesApi from '@/core/services/apiInsurance/admin/facilities'

export function isInsuranceContext(programContext) {
  return programContext === 'insurance'
}

export function getClinicPatientApi(programContext) {
  return isInsuranceContext(programContext) ? insurancePatientApi : normalPatientApi
}

export function getClinicCitiesApi(programContext) {
  return isInsuranceContext(programContext) ? insuranceCitiesApi : normalCitiesApi
}

export function getClinicFacilitiesApi(programContext) {
  return isInsuranceContext(programContext) ? insuranceFacilitiesApi : normalFacilitiesApi
}

export function defaultClinicSearchFilters() {
  return {
    name: null,
    cities_id: null,
    zip_codes_id: null,
    date_birth: null,
    create: null,
    email: null,
    phone: null,
    gender: null,
    status: null,
    facilities_id: null,
  }
}

export function buildClinicSearchPayload(filters = {}) {
  const payload = {}
  Object.entries(filters).forEach(([key, value]) => {
    if (value == null || value === '') return
    if (Array.isArray(value) && !value.length) return
    payload[key] = value
  })
  return payload
}

function normalizePatientId(value) {
  if (value == null || value === '') return null
  if (typeof value === 'object') {
    return value.id ?? value.user_id ?? value.user?.id ?? null
  }
  const id = Number(value)
  return Number.isNaN(id) ? value : id
}

export function extractCreatedPatientId(response) {
  if (!response) return null

  const topLevel =
    normalizePatientId(response.patient_id) ??
    normalizePatientId(response.id) ??
    normalizePatientId(response.registro) ??
    normalizePatientId(response.data)

  if (topLevel != null) return topLevel

  if (response.data && typeof response.data === 'object') {
    return (
      normalizePatientId(response.data.user_id) ??
      normalizePatientId(response.data.id) ??
      normalizePatientId(response.data.user?.id)
    )
  }

  return null
}

export function mapClinicPatientToWlForm(patient) {
  if (!patient) return null
  return {
    user_id: patient.id,
    first_name: patient.name || patient.first_name || '',
    last_name: patient.lastname || patient.last_name || '',
    email: patient.email || '',
    phone: patient.phone || '',
    dob: patient.date_birth
      ? String(patient.date_birth).slice(0, 10)
      : patient.dob
      ? String(patient.dob).slice(0, 10)
      : '',
  }
}

export async function searchClinicPatients(
  programContext,
  perPage = 15,
  filters = {},
  page = 1
) {
  const api = getClinicPatientApi(programContext)
  const payload = buildClinicSearchPayload(filters)
  const response =
    page > 1
      ? await api.patientFilterPagination(perPage, page, payload)
      : await api.patientFilter(perPage, payload)

  const items = Array.isArray(response?.data)
    ? response.data
    : Array.isArray(response?.data?.data)
    ? response.data.data
    : []

  return {
    items,
    total: response?.total ?? items.length,
    current_page: response?.current_page ?? page,
  }
}
